import { toolsApi, toolRunsApi } from '@/lib/api';
import { generateEditorImage as generate } from './editor_image_generation';

// The same credit/job contract is shared by web, Mac and Windows editors.
export function generateEditorImage(options) {
  return generate(options, { run: toolsApi.run, poll: toolRunsApi.poll });
}
